import DeleteIcon from '@mui/icons-material/Delete';

import s from './DeleteButton.module.css';

type Props = {
  onDelete: () => void;
};

function DeleteButton({ onDelete }: Props) {
  return (
    <button type="button" className={s.deleteNodeButton} onClick={onDelete}>
      <DeleteIcon />
    </button>
  );
}

export default DeleteButton;
